import React, { ReactNode } from 'react';
import { SubMenuAnimationWrapper } from './SubMenuContainer.styles';

type SubMenuContainerProps = {
  children: ReactNode;
  isOpen: boolean;
};
const SubMenuContainer = ({ children, isOpen }: SubMenuContainerProps) => (
  <SubMenuAnimationWrapper
    id="mobile-nav-sub-menu"
    className={isOpen ? 'visible' : ''}
  >
    {children}
  </SubMenuAnimationWrapper>
);

export default SubMenuContainer;
